<template>
  <div>
    <dashboard-page-title
      :showFilter="false"
      :showSearch="false"
      :showExportation="false"
      :showAddBtn="false"
    >
      {{ $t('auth.privacyPolicy') }}
    </dashboard-page-title>

    <b-container fluid>
      <b-row>
        <b-col>
          <b-card class="shadow-sm">
            <h3 class="mb-3 text-right">سياسة الخصوصية لمنصة إبل</h3>
            <p class="text-muted text-right">
              هذه الصفحة تحتوي على نص تجريبي (Dummy Data) لسياسة الخصوصية، ويُستخدم فقط لعرض الشكل النهائي، ويمكن
              استبداله لاحقًا بالصيغة القانونية المعتمدة.
            </p>

            <hr>

            <h5 class="mt-3 mb-2 text-right">أولًا: المعلومات التي نقوم بجمعها</h5>
            <ul class="text-right">
              <li>بيانات الهوية الأساسية مثل الاسم ورقم الجوال والبريد الإلكتروني.</li>
              <li>معلومات الاستخدام، مثل سجلات الدخول وحركات التصفح داخل المنصة.</li>
              <li>أي بيانات أخرى يقوم المستخدم بإدخالها طوعًا ضمن نماذج المنصة.</li>
            </ul>

            <h5 class="mt-4 mb-2 text-right">ثانيًا: كيفية استخدام المعلومات</h5>
            <p class="text-right">
              تُستخدم بياناتك لتحسين تجربتك في المنصة، وتقديم الخدمات، والتواصل معك بشأن التحديثات أو الإشعارات المهمة،
              وكذلك لتحسين جودة وأداء الخدمات بشكل عام.
            </p>

            <h5 class="mt-4 mb-2 text-right">ثالثًا: مشاركة البيانات</h5>
            <p class="text-right">
              لا تتم مشاركة بياناتك الشخصية مع أي طرف ثالث إلا في الحالات التي يقتضيها النظام، أو لتنفيذ خدمة محددة
              بموافقتك، أو مع مزودي الخدمات التقنيين الموثوقين مع الالتزام التام بضوابط السرية.
            </p>

            <h5 class="mt-4 mb-2 text-right">رابعًا: حماية المعلومات</h5>
            <p class="text-right">
              تتخذ المنصة إجراءات تقنية وتنظيمية مناسبة لحماية بياناتك من الوصول غير المصرح به أو التغيير أو الاستخدام
              غير المشروع، مع الأخذ في الاعتبار أن أمن المعلومات عبر الإنترنت لا يمكن أن يكون مضمونًا بنسبة 100%.
            </p>

            <h5 class="mt-4 mb-2 text-right">خامسًا: حقوق المستخدم</h5>
            <ul class="text-right">
              <li>الاطلاع على بياناته الشخصية المسجلة في المنصة.</li>
              <li>طلب تعديل أو تحديث بعض البيانات غير الدقيقة.</li>
              <li>طلب حذف الحساب وفقًا للضوابط المعمول بها في المنصة.</li>
            </ul>

            <h5 class="mt-4 mb-2 text-right">سادسًا: التعديلات على سياسة الخصوصية</h5>
            <p class="text-right">
              تحتفظ المنصة بالحق في تعديل سياسة الخصوصية في أي وقت، ويتم إخطار المستخدمين بالتعديلات الجوهرية من خلال
              الإشعارات داخل المنصة أو عبر وسائل الاتصال المسجلة.
            </p>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { core } from '@/config/pluginInit'

export default {
  name: 'PrivacyPolicyPage',
  mounted () {
    core.index()
  }
}
</script>
